module.exports = __webpack_public_path__ + "static/media/boxesCrane7.dd33c101.png";